const VIDEO_FORMAT = {
    Mono: 0,
    Stereo_TB: 1,
    Stereo_LR: 2
};

const EYE = {
    Left: 1,
    Right: 2
};

module.exports = { VIDEO_FORMAT, EYE };




// WEBPACK FOOTER //
// ./src/js/plugins/immersive/types.js